module.exports = __webpack_public_path__ + "media/img/angle-9425cbd67fa88aa69293610e4157fde6.svg";